import { call, put } from 'redux-saga/effects';
import { takeEvery } from 'redux-saga';
import config from '../../../config';
import request from 'superagent';

//v4
export function* getGameDayRulesSaga() {
    yield* takeEvery("SCHEDULE_MANAGER/GAMEDAY_RULES/FETCH", function* (action) {

        try {
            const result = yield call(function () {
                return request.get(`${config.apiEndpoint}/api/v4/schedule/rules/gamedays/${action.idSeason}`)
                    .set('Authorization', `Bearer ${localStorage.getItem('sportslogic.authtoken')}`)
                    .then((data) => JSON.parse(data.text));
            });

            if (result && result.success) {
                yield put({ type: 'SCHEDULE_MANAGER/GAMEDAY_RULES/SET', rules: result.rules });
            } else {
                yield put({ type: 'SCHEDULE_MANAGER/GAMEDAY_RULES/FETCH_FAILED', result });
            }
        } catch (e) {
            yield put({ type: 'SCHEDULE_MANAGER/GAMEDAY_RULES/FETCH_FAILED', e });
        }
    });
}

//v4
export function* associateGameDayRuleWithFlightSaga() {
    yield* takeEvery("SCHEDULE_MANAGER/GAMEDAY_RULES/ASSOCIATE_WITH_FLIGHT", function* (action) {

        const result = yield call(({ idFlight, idRule }) => {
            return request.post(`${config.apiEndpoint}/api/v4/flights/associate/gameday/${idFlight}/${idRule}`)
                .send({})
                .set('Authorization', `Bearer ${localStorage.getItem('sportslogic.authtoken')}`)
                .then((data) => JSON.parse(data.text));
        }, action);

        if (result && result.success) {
            // TODO ?
            yield put({
                type: 'DIVISIONS/ASSOCIATE/GAMEDAY',
                idFlight: result.IdFlight,
                idRule: result.IdRule,
                idAssociation: result.idAssociation
            });
        }

    });
}

//v4
export function* removeGameDayRuleAssociationFromFlight() {
    yield* takeEvery("SCHEDULE_MANAGER/GAMEDAY_RULES/REMOVE_ASSOCIATION_FROM_FLIGHT", function* (action) {
        const result = yield call(({ idRuleAssociation }) => {
            return request.del(`${config.apiEndpoint}/api/v4/flights/remove/gameday/${action.idRuleAssociation}`)
                .set('Authorization', `Bearer ${localStorage.getItem('sportslogic.authtoken')}`)
                .then((data) => JSON.parse(data.text));
        }, action);

        if (result && result.success) {
            // TODO ?
            yield put({
                type: 'DIVISIONS/REMOVE_ASSOCIATION/GAMEDAY',
                idAssociation: action.idRuleAssociation
            });
        }
    });
}
